'use strict';

var processInclude = require('base/util');

$(() => {
    processInclude(require('./order/order'));
});
